import { FileSizes } from '../../enums/file-sizes.enum';
import { getByteReference } from '../get-byte-reference/get-byte-reference.util';

export const convertBytes = (
  bytes: number,
  convertTo: FileSizes,
  fractionDigits: number = 2,
  suffix?: string
): string => {
  const byteReference: number | null = getByteReference(convertTo);

  if (byteReference === null) {
    return '';
  }

  return `${(bytes / byteReference).toFixed(fractionDigits)}${
    suffix ? ' ' + suffix : ''
  }`;
};
